import { render, staticRenderFns } from "./TeacherCourses.vue?vue&type=template&id=79dfed74&scoped=true"
import script from "./TeacherCourses.vue?vue&type=script&lang=js"
export * from "./TeacherCourses.vue?vue&type=script&lang=js"
import style0 from "./TeacherCourses.vue?vue&type=style&index=0&id=79dfed74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79dfed74",
  null
  
)

export default component.exports